export default "__VITE_ASSET__Bz4n317R__"